import { filter, Observable, of, take } from 'rxjs';
import { inject } from '@angular/core';
import { SearchMarketService } from '../../../../shared/services/search-market.service';
import { UserService } from '../../../../shared/services/user.service';
import { ClientPortalService } from '../../../../shared/services/client-portal.service';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';

export const SearchMarketResolver: ResolveFn<any> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): Observable<any> => 
  {

  // MP-5754: a CLIENT reaches People only for Worked Together, which takes no
  // search market; the firm search-market endpoint answers 403 for that role
  // and the auth interceptor would log the user out.
  if (inject(ClientPortalService).isClientPortalUser()) {
    return of([]);
  }
  const userService = inject(UserService);
  const searchMarketService = inject(SearchMarketService)
  const user = userService.getSessionUser();
  return searchMarketService.getAllFirmSearchMarket(user.firm._id)
  .pipe(
    filter<any>((searchMarket: any) => !!searchMarket),
    take(1)
  );
}
